import React, { useState } from 'react';
import {
	Collapse,
	Container,
	Navbar,
	NavbarBrand,
	NavbarToggler,
} from 'reactstrap';
import { NavBarContent } from './NavbarContent.js';
import { LL } from './LL.js';

export const NavbarWrapper = ({ anonymous = false, nonanonymous = false, ...props }) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggle = () => setIsOpen(!isOpen);
	const bgColor = props.transparent ? "bg-transparent" : "navbar_bg_color";
	let logoUrl = "https://static.sibilus.eu/gfx/pentus-logo-color-0.svg";
	let lightBgClass = "";

	if(props.lightbg) {
		logoUrl = "https://static.sibilus.eu/gfx/pentus-logo-color-black-0.svg";
		lightBgClass = "light_bg_nav";
	}

	if (props.selectedElemId) {
		const element = document.getElementById(props.selectedElemId);
		if (element) {
			element.classList.remove("nav_not_selected");
			element.classList.add("nav_selected");
		}
	}

	return (
		// @ts-ignore
		<Navbar expand="lg" className={bgColor} container=''>
			<Container className={lightBgClass} >
				<NavbarBrand href={LL('/')} className='ps-0'>
					<img src={logoUrl} width={122} height={54} alt='our logo' />
				</NavbarBrand>
				<NavbarToggler color={"light"} onClick={toggle} />
				<Collapse id="collapsernavbar" isOpen={isOpen} navbar>
					<NavBarContent anonymous={anonymous} nonanonymous={nonanonymous} />
				</Collapse>
			</Container>
		</Navbar>
	);
}

const SibilusNavbar = ({ anonymous = false, nonanonymous = false, ...props }) => {
	return (
		<div  data-render-target="SibilusNavbar-root">
			<NavbarWrapper anonymous={anonymous} nonanonymous={nonanonymous} {...props} />
		</div>
	)
};

export default SibilusNavbar;
